var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('TopButton'),_c('v-row',[_c('v-col',{attrs:{"sm":"4","md":"3"}},[_c('DocsNav')],1),_c('v-col',{staticClass:"pl-6",attrs:{"sm":"8","md":"9"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }